<mat-form-field floatLabel="never" [ngClass]="classField()">
    <mat-select placeholder="..." [formControl]="control()">
      <mat-option [value]="'OwnsHouse'"><span translate>Owns house</span></mat-option>
      <mat-option [value]="'RentsHouse'"><span translate>Rents house</span></mat-option>
      <mat-option [value]="'InRooms'"><span translate>In rooms</span></mat-option>
      <mat-option [value]="'AtParents'"><span translate>Living with parents</span></mat-option>
      <mat-option [value]="'AtPartner'"><span translate>Living with partner</span></mat-option>
    </mat-select>
  </mat-form-field>